import { createCustomerOnDB } from "../../apis/customer";

export const getTerifyName = async (
  customerType,
  hasSmartMeter,
  energyConsumption,
  email = null,
) => {
  console.log("typeof", typeof email);
  let tariffName = "greenman_rlm_spot_business_generic";
  if (
    customerType == "business" &&
    hasSmartMeter == true &&
    email === "service-lis@greenman.energy"
  )
    tariffName =
      "greenman_rlm_spot_business_generic_2,greenman_rlm_spot_business_generic,greenman_slp_spot_business_generic_2,greenman_slp_single_step_business_generic_2";
  else if (
    customerType == "business" &&
    hasSmartMeter == true &&
    energyConsumption >= 500000
  )
    tariffName =
      "greenman_rlm_spot_business_generic_2,greenman_rlm_spot_business_generic,greenman_slp_single_step_business_generic_2";
  else if (
    customerType == "business" &&
    hasSmartMeter == true &&
    energyConsumption >= 100000
  )
    tariffName =
      "greenman_rlm_spot_business_generic,greenman_slp_single_step_business_generic_2";
  else if (
    customerType == "business" &&
    hasSmartMeter == true &&
    energyConsumption < 100000
  ) {
    tariffName =
      "greenman_slp_spot_business_generic_2,greenman_slp_single_step_business_generic_2";
  } else if (customerType == "business" && hasSmartMeter == false)
    tariffName = "greenman_slp_single_step_business_generic_2";
  else if (customerType == "private" && hasSmartMeter == true) {
    tariffName =
      "greenman_slp_spot_household_generic,greenman_slp_single_step_household_generic";
    // const allowedDomains = ["@greenman.com", "@greenman.energy", "@yes-and.io"];

    // const isValid = allowedDomains.some(domain => email.endsWith(domain));
    // tariffName = isValid
    //   ? "greenman_slp_spot_household_generic_2,greenman_slp_single_step_household_generic"
    //   : "greenman_slp_spot_household_generic,greenman_slp_single_step_household_generic";
  } else if (customerType == "private" && hasSmartMeter == false)
    tariffName = "greenman_slp_single_step_household_generic";
  return tariffName;
};

export const saveOnDB = async (data, create = false) => {
  try {
    console.log(data, "datatatawta");
    let cleanValue = germanToUSNumber(data?.energyConsumption)?.replace(
      /,/g,
      "",
    );
    let consumptionValue = cleanValue ? Number(cleanValue) : null;
    const payload = {
      ...data,
      ...data?.personalInformation,
      ...data?.deliveryAddress,
      ...data?.exchangeDetails,
      ...data?.paymentDetails,
      tariff_type: localStorage.getItem("tariff_name"),
    };
    if (data?.energyConsumption) payload.annual_consumption = consumptionValue;
    if (data?.customerType)
      payload.is_business = data?.customerType == "business" ? true : false;
    createCustomerOnDB(payload, create);
    // if (response?.status === "success") {
    // localStorage.setItem("customer_id", response?.result?.id); // Move to the next step after successful creation
  } catch (error) {
    console.error("Error creating customer:", error);
  }
};

export const convertToGermanCurrencyWithoutSymbol = (value) => {
  return new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const addCommasToNumber = (value) => {
  let cleanedInput = value;
  if (value == "") return value;
  // if (!/^\d+([.,]\d*)?$/.test(value)) return value;
  // Try to detect format
  if (/^\d{1,3}(,\d{3})+(\.\d+)?$/.test(cleanedInput)) {
    // US format: e.g., "12,000,000.00"
    cleanedInput = cleanedInput.replace(/,/g, "");
  } else if (/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(cleanedInput)) {
    // German format: e.g., "46.000,05"
    cleanedInput = cleanedInput.replace(/\./g, "").replace(",", ".");
  } else {
    // Generic fallback: replace comma with dot if it's the decimal separator
    // const commaIndex = cleanedInput.lastIndexOf(",");
    // const dotIndex = cleanedInput.lastIndexOf(".");

    // if (commaIndex > dotIndex) {
    //   cleanedInput = cleanedInput.replace(/\./g, "").replace(",", ".");
    // } else {
    //   cleanedInput = cleanedInput.replace(/,/g, "").replace(/./g, "");
    // }
    cleanedInput = cleanedInput.replace(/\./g, "").replace(/\,/, "");
  }
  const numberValue = parseFloat(cleanedInput);

  return isNaN(numberValue)
    ? value
    : new Intl.NumberFormat("de-DE", {
        maximumFractionDigits: 0,
      }).format(numberValue);
};

export const germanToUSNumber = (germanNumStr) => {
  if (typeof germanNumStr === "string") {
    // Step 1: Remove thousand separator (dot)
    // Step 2: Replace decimal separator (comma) with dot
    let usNumberStr = germanNumStr.replace(/\./g, "").replace(",", ".");

    // Optional: convert to number type if needed
    let numberValue = parseFloat(usNumberStr);

    // Optional: format back to US string with commas
    // This is to ensure consistent formatting (e.g., 4500 -> 4,500.00)
    return numberValue.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
};

const vatCalulation = (amount, percentage) =>
  amount + (amount / 100) * percentage;

export const calculateTariffDetails = (payload, yearSavings) => {
  // Initialize result object
  const result = {};

  // Extract data from payload
  const offerItems = payload?.offer_item_price_results || [];
  const totalPriceResults = payload?.total_price_results || [];

  // Helper function to find items by name
  const findItem = (name) => offerItems.find((item) => item.name === name);
  const findTotalPrice = (unit) =>
    totalPriceResults.find((item) => item.unit === unit);

  const totalYearPrice = findTotalPrice("ct/y")?.total_price_gross / 100;

  if (yearSavings)
    result.yearSavings = convertToGermanCurrencyWithoutSymbol(
      yearSavings - totalYearPrice,
    );

  // if (yearSavings)
  //   result.yearSavings = convertToGermanCurrencyWithoutSymbol(
  //     ((yearSavings - totalYearPrice) / yearSavings) * 100,
  //   ); //ok
  // result.yearSavings = yearSavings;

  const workingPrice = findItem("working_price_1");

  // GME Display Name
  const gmeDisplayName = payload?.tariff_name || "N/A";
  const isBusiness = [
    "greenman_slp_spot_business_generic_2",
    "greenman_rlm_spot_business_generic",
    "greenman_slp_single_step_business_generic_2",
    "greenman_rlm_spot_business_generic_2",
  ].includes(gmeDisplayName);
  result.display_tariff_name = payload?.display_tariff_name || "N/A";
  result.title =
    payload?.display_tariff_name == "Greenman Fix Business"
      ? "GME Fix"
      : "GME Dynamic";
  const baseFee = findItem("base_fee");
  const serviceCosts = findItem("service_costs_1");

  // Energie-Servicegebühr (Energy Service Fee)
  let serviceFee;
  if (gmeDisplayName == "greenman_slp_spot_business_generic_2")
    serviceFee = findItem("spread_comercial_clients");
  else if (
    [
      "greenman_rlm_spot_business_generic",
      "greenman_rlm_spot_business_generic_2",
    ].includes(gmeDisplayName)
  )
    serviceFee = findItem("spread_rlm");
  else if (
    [
      "greenman_slp_spot_household_generic",
      "greenman_slp_spot_household_generic_2",
    ].includes(gmeDisplayName)
  )
    serviceFee = findItem("spread_household_clients");

  // Durchschnittlicher Arbeitspreis (Average energy price)
  let totalCost =
    workingPrice?.associated_costs.reduce((sum, cost) => {
      return (
        sum + vatCalulation(cost.cost_per_unit_net, workingPrice?.vat_rate)
      );
    }, 0) || 0;

  if (
    [
      "greenman_slp_spot_household_generic",
      "greenman_slp_single_step_household_generic",
    ].includes(gmeDisplayName)
  )
    result.networkCharges =
      convertToGermanCurrencyWithoutSymbol(
        vatCalulation(baseFee?.price_net, workingPrice?.vat_rate) / 12 / 100,
      ) || 0;

  result.isBusiness = isBusiness;

  // Grundpreis (Base fee)
  if (
    [
      "greenman_slp_spot_household_generic",
      "greenman_slp_spot_household_generic_2",
    ].includes(gmeDisplayName)
  )
    result.GMEFee =
      convertToGermanCurrencyWithoutSymbol(serviceCosts?.price_gross / 100) ||
      0;

  // Monthly Price (€/month)
  if (isBusiness) {
    if (yearSavings)
      result.yearSavings = convertToGermanCurrencyWithoutSymbol(
        yearSavings - findTotalPrice("ct/y")?.total_price_net / 100,
      ); //ok

    result.monthlyPrice =
      convertToGermanCurrencyWithoutSymbol(
        findTotalPrice("ct/m")?.total_price_net / 100,
      ) || 0; //ok
    result.yearlyPrice =
      convertToGermanCurrencyWithoutSymbol(
        findTotalPrice("ct/y")?.total_price_net / 100,
      ) || 0; //ok
    if (gmeDisplayName == "greenman_slp_single_step_business_generic_2") {
      result.basePrice =
        convertToGermanCurrencyWithoutSymbol(baseFee?.price_net / 12 / 100) ||
        0; //ok
    } else {
      result.basePrice =
        convertToGermanCurrencyWithoutSymbol(serviceCosts?.price_net / 100) ||
        0; //ok
    }
    if (gmeDisplayName == "greenman_slp_single_step_business_generic_2") {
      result.exchangeElectricityPrice =
        convertToGermanCurrencyWithoutSymbol(
          workingPrice?.associated_costs.find(
            (cost) => cost.name === "power_cost",
          )?.cost_per_unit_net,
        ) || 0;
    } else {
      result.exchangeElectricityPrice =
        convertToGermanCurrencyWithoutSymbol(
          workingPrice?.associated_costs.find(
            (cost) => cost.name === "avg_spot_price",
          )?.cost_per_unit_net,
        ) || 0;
    }

    if (gmeDisplayName == "greenman_slp_spot_business_generic_2") {
      result.surchargesTaxes =
        convertToGermanCurrencyWithoutSymbol(
          workingPrice?.associated_costs.reduce((sum, cost) => {
            return cost.name !== "avg_spot_price"
              ? sum + cost.cost_per_unit_net
              : sum;
          }, 0),
        ) || 0;
    } else if (
      gmeDisplayName == "greenman_slp_single_step_business_generic_2"
    ) {
      result.surchargesTaxes =
        convertToGermanCurrencyWithoutSymbol(
          workingPrice?.associated_costs.reduce((sum, cost) => {
            return cost.name !== "power_cost"
              ? sum + cost.cost_per_unit_net
              : sum;
          }, 0),
        ) || 0;
    } else
      result.surchargesTaxes =
        convertToGermanCurrencyWithoutSymbol(
          workingPrice?.associated_costs.find((cost) => cost.name === "stromst")
            ?.cost_per_unit_net,
        ) || 0;
    result.energyServiceFee = serviceFee?.price_net || 0;
    totalCost =
      workingPrice?.associated_costs.reduce((sum, cost) => {
        return sum + cost.cost_per_unit_net;
      }, 0) || 0;
    if (
      [
        "greenman_slp_spot_business_generic_2",
        "greenman_slp_single_step_business_generic_2",
      ].includes(gmeDisplayName)
    )
      result.networkCharges =
        convertToGermanCurrencyWithoutSymbol(baseFee?.price_net / 12 / 100) ||
        0;
    // Grundpreis (Base fee)
    if (
      [
        "greenman_slp_spot_business_generic_2",
        "greenman_rlm_spot_business_generic",
        "greenman_rlm_spot_business_generic_2",
      ].includes(gmeDisplayName)
    )
      result.GMEFee =
        convertToGermanCurrencyWithoutSymbol(serviceCosts?.price_net / 100) ||
        0;
  } else {
    result.monthlyPrice =
      convertToGermanCurrencyWithoutSymbol(
        findTotalPrice("ct/m")?.total_price_gross / 100,
      ) || 0; //ok
    result.yearlyPrice =
      convertToGermanCurrencyWithoutSymbol(
        findTotalPrice("ct/y")?.total_price_gross / 100,
      ) || 0; //ok
    if (
      [
        "greenman_slp_spot_household_generic",
        "greenman_slp_spot_household_generic_2",
      ].includes(gmeDisplayName)
    ) {
      result.basePrice = result?.GMEFee;
      // convertToGermanCurrencyWithoutSymbol(serviceCosts?.price_gross / 100) ||
      // 0; //ok
    } else {
      result.basePrice =
        convertToGermanCurrencyWithoutSymbol(baseFee?.price_gross / 12 / 100) ||
        0; //ok
    }

    if (
      [
        "greenman_slp_spot_household_generic",
        "greenman_slp_spot_household_generic_2",
      ].includes(gmeDisplayName)
    ) {
      result.exchangeElectricityPrice =
        convertToGermanCurrencyWithoutSymbol(
          vatCalulation(
            workingPrice?.associated_costs.find(
              (cost) => cost.name === "avg_spot_price",
            )?.cost_per_unit_net,
            workingPrice?.vat_rate,
          ),
        ) || 0;
    } else {
      result.exchangeElectricityPrice =
        convertToGermanCurrencyWithoutSymbol(
          vatCalulation(
            workingPrice?.associated_costs.find(
              (cost) => cost.name === "power_cost",
            )?.cost_per_unit_net,
            workingPrice?.vat_rate,
          ),
        ) || 0;
    }

    // Umlagen, Netzentgelt & Steuern (Surcharges, network charges & taxes)
    if (
      [
        "greenman_slp_spot_household_generic",
        "greenman_slp_spot_household_generic_2",
      ].includes(gmeDisplayName)
    )
      result.surchargesTaxes =
        convertToGermanCurrencyWithoutSymbol(
          workingPrice?.associated_costs.reduce((sum, cost) => {
            return cost.name !== "avg_spot_price"
              ? sum +
                  vatCalulation(cost.cost_per_unit_net, workingPrice?.vat_rate)
              : sum;
          }, 0),
        ) || 0;
    else if (
      ["greenman_slp_single_step_household_generic"].includes(gmeDisplayName)
    )
      result.surchargesTaxes =
        convertToGermanCurrencyWithoutSymbol(
          workingPrice?.associated_costs.reduce((sum, cost) => {
            return cost.name !== "power_cost"
              ? sum +
                  vatCalulation(cost.cost_per_unit_net, workingPrice?.vat_rate)
              : sum;
          }, 0),
        ) || 0;
    // stromst (Surcharge taxes)
    else
      result.surchargesTaxes =
        convertToGermanCurrencyWithoutSymbol(
          vatCalulation(
            workingPrice?.associated_costs.find(
              (cost) => cost.name === "stromst",
            )?.cost_per_unit_net,
            workingPrice?.vat_rate,
          ),
        ) || 0;
    result.energyServiceFee = serviceFee?.price_gross || 0;
  }

  // Yearly Price (€/year)

  // Base Price (€/month)

  // Energy Price ct/kWh
  result.energyPrice =
    convertToGermanCurrencyWithoutSymbol(
      vatCalulation(
        workingPrice?.item_amount?.calculation_data.find(
          (data) => data.name === "working_price_1_net",
        )?.value,
        workingPrice?.vat_rate,
      ),
    ) || 0; //ok

  // Börsenstrompreis (Exchange electricity price)

  // variable remuneration
  if (
    [
      "greenman_slp_spot_household_generic",
      "greenman_slp_spot_household_generic_2",
    ].includes(gmeDisplayName)
  )
    result.variableremuneration = result.exchangeElectricityPrice;

  result.averageEnergyPrice = convertToGermanCurrencyWithoutSymbol(
    totalCost + result?.energyServiceFee,
  );
  // result.surchargesTaxes + result.energyServiceFee;

  // Netzentgelt (Network charges)
  if (
    [
      "greenman_slp_spot_household_generic",
      "greenman_slp_spot_household_generic_2",
      "greenman_slp_single_step_household_generic",
    ].includes(gmeDisplayName)
  )
    result.networkCharges =
      convertToGermanCurrencyWithoutSymbol(
        vatCalulation(baseFee?.price_net, workingPrice?.vat_rate) / 12 / 100,
      ) || 0;

  // Summe der monatlichen Gebühren (Total monthly fees)
  result.totalMonthlyFees = result?.GMEFee
    ? convertToGermanCurrencyWithoutSymbol(
        (result?.networkCharges
          ? parseFloat(germanToUSNumber(result?.networkCharges ?? 0))
          : 0) + parseFloat(germanToUSNumber(result?.GMEFee)),
      )
    : result?.networkCharges;

  result.tariff_name = gmeDisplayName;
  result.vat_rate = workingPrice?.vat_rate;
  return result;
};
